import { render, staticRenderFns } from "./ModalFirmantes.vue?vue&type=template&id=2aebb0f0&"
import script from "./ModalFirmantes.vue?vue&type=script&lang=js&"
export * from "./ModalFirmantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports